export default "__VITE_ASSET__JCjVi6is__"